import { IonRow, IonCol, IonIcon } from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tab,
  Tabs,
  Collapse,
  Button,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { NavLink, useParams } from 'react-router-dom';
import { RootState } from '../../models/RootState';
import {
  getAllMarketsByEvent,
  clearExchcngeBets,
  fetchOpenBets,
  fetchEvent,
  getSecondaryMarketsByEvent,
  setExchEvent,
  getSecondaryMatchOddsByEvent,
  updateEventScorecard,
  getCurrencyTypeFromToken,
  getLineMarketsByEvent,
  getPremiumMarkets,
  fetchPremiummarketsByEventId,
  getBookmakerMarketsByEvent,
  getFancyMarketsByEvent,
  getSapTokenFromToken,
  getHouseIdFromToken,
  getParentIdFromToken,
  getAccountIdFromToken,
} from '../../store';
import { FancyMarketDTO } from '../../models/common/FancyMarketDTO';
import BmMTable from '../../components/ExchBookmakerMarketTable/ExchBookmakerMarketTable';
import FMTable from '../../components/ExchFancyMarketsTable/ExchFancyMarketsTable';
import MatchOddsTable from '../../components/ExchMatchOddsTable/ExchMatchOddsTable';
import ExchOpenBets from '../../components/ExchOpenBets/ExchOpenBets';
import CricketLiveStream from '../../components/Livestream/CricketLiveStream';
import PremiumMarketsView from '../../components/PremiumMarkets/PremiumMarketsView';
import './ExchangeAllMarkets.scss';
import { PlaceBetRequest } from '../../models/BsData';
import { UserBet } from '../../models/UserBet';
import TabPanel from '../../components/TabPanel/TabPanel';
import {
  SecondaryMarkets,
  SelectedObj,
} from '../../models/ExchangeSportsState';
import {
  subscribeWsForSecondaryMarkets,
  subscribeWsForFancyMarkets,
  subscribeWsForSecondaryMatchOdds,
  unsubscribeAllWsforEvents,
  checkStompClientSubscriptions,
  subscribeSportRadarEventOdds,
  disconnectToWS,
  disConnectToPushNotificationWS,
  connectToPushNotification,
  subscribeWsForNotifications,
  checkPNStompClientSubscriptions,
  unsubscribePNWsforEvents,
  subscribeWsForNotificationsPerAdminAllMarkets,
  subscribeWsForNotificationsPerAdmin,
} from '../../webSocket/webSocket';
import { EventDTO } from '../../models/common/EventDTO';
import { MatchOddsDTO } from '../../models/common/MatchOddsDTO';
import API from '../../api';
import { CURRENCY_TYPE_FACTOR } from '../../constants/CurrencyTypeFactor';
import Script from 'next/script';
import axios from 'axios';
import { SPEventDTO } from '../../models/common/SPEventDTO';
import tvIcon from '../../assets/images/common/tv.svg';
import scoreIcon from '../../assets/images/common/score.svg';
import CountDown from './countDown';
import BottomSheet from './bottomSheet';
import { BookmakerDTO } from '../../models/common/BookmakerDTO';
import API_SPORT_FEED from '../../api-services/sportfeed-api';
import API_V2 from '../../api-services/svls-api';
import { PROVIDER_ID } from '../../constants/Branding';
import { SPToBFIdMap } from '../../util/stringUtil';
type StoreProps = {
  bmMData: BookmakerDTO[];
  fmData: FancyMarketDTO[];
  selectedEvent: SelectedObj;
  eventData: EventDTO;
  secondaryMatchOdds: MatchOddsDTO[];
  lineMarkets: MatchOddsDTO[];
  secondaryMarkets: SecondaryMarkets;
  bets: PlaceBetRequest[];
  openBets: UserBet[];
  totalOrders: number;
  loggedIn: boolean;
  selectedEventType: { id: ''; name: ''; slug: '' };
  clearExchcngeBets: () => void;
  fetchOpenBets: (eventId: string, sportId: string) => void;
  fetchEvent: (
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  fetchPremiummarketsByEventId: (
    providerId: string,
    sportId: string,
    competitionId: string,
    eventId: string,
    marketTime: string
  ) => void;
  setExchEvent: (event: SelectedObj) => void;
  updateEventScorecard: (scorecard: any) => void;
  seEventData: SPEventDTO;
  topicUrls: any;
  houseId: string;
  parentId: string;
  accountId: string;
  triggerFetchMarkets: number;
  triggerFetchOrders: number;
  betFairWSConnected: boolean;
  pushNotifWSConnection: boolean;
};

type RouteParams = {
  eventType: string;
  competition: string;
  eventId: string;
  eventInfo: string;
};

type AllMarketsProps = StoreProps & {
  returnBackupStreamUrl: (url: string) => void;
  returnEventId: (eventId: string) => void;
  returnInplayValue: (value: boolean) => void;
  returnShouldShowStream: (value: boolean) => void;
  handleLiveStrem: (Value: boolean) => void;
};

const ExchAllMarkets: React.FC<AllMarketsProps> = (props) => {
  const routeParams = useParams<RouteParams>();
  const [scorecardAccordion, setScorecardAccordion] = useState<boolean>(true);
  const [liveAccordion, setLiveAccordion] = useState<boolean>(true);
  const [openBetslip, setOpenBetslip] = useState<boolean>(true);
  const [backupStreamUrl, setBackupStreamUrl] = useState<string>(null);
  const [fancyTabVal, setFancyTabVal] = useState(0);
  const [showActionSheet, setShowActionSheet] = useState(false);
  const [cFactor, setCFactor] = useState<number>(
    CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]
  );
  const {
    bmMData,
    fmData,
    selectedEvent,
    eventData,
    secondaryMatchOdds,
    secondaryMarkets,
    bets,
    openBets,
    totalOrders,
    loggedIn,
    clearExchcngeBets,
    fetchOpenBets,
    selectedEventType,
    fetchEvent,
    fetchPremiummarketsByEventId,
    setExchEvent,
    updateEventScorecard,
    seEventData,
    returnBackupStreamUrl,
    returnEventId,
    returnInplayValue,
    returnShouldShowStream,
    handleLiveStrem,
    topicUrls,
    houseId,
    parentId,
    accountId,
    triggerFetchMarkets,
    triggerFetchOrders,
    betFairWSConnected,
    pushNotifWSConnection
  } = props;
  let selectionEventId = null;
  const [scorecardID, setScorecardID] = useState<string>('');
  const [exposureMap, setExposureMap] = useState(null);
  const [matchOddsBaseUrl, setMatchOddsBaseUrl] = useState<string>('');
  const [matchOddsTopic, setMatchOddsTopic] = useState<string>('');
  const [bookMakerBaseUrl, setBookMakerBaseUrl] = useState<string>('');
  const [bookMakerTopic, setBookMakerTopic] = useState<string>('');
  const [fancyBaseUrl, setFancyBaseUrl] = useState<string>('');
  const [fancyTopic, setFancyTopic] = useState<string>('');
  const [premiumBaseUrl, setPremiumBaseUrl] = useState<string>('');
  const [premiumTopic, setPremiumTopic] = useState<string>('');
  const [enableFetchOrders, setEnableFetchOrders] = useState<boolean>(false);

  useEffect(() => {
    unsubscribeAllWsforEvents();
  }, [selectedEvent]);

  useEffect(() => {
    if (!loggedIn) {
      unsubscribeAllWsforEvents();
    }
    return () => {
      unsubscribeAllWsforEvents();
    };
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn && eventData) {
      returnBackupStreamUrl(backupStreamUrl);
      returnEventId(eventData.eventId);
      handleLiveStrem(liveAccordion);
      returnInplayValue(eventData.status === "IN_PLAY")
      returnShouldShowStream(eventData.competitionId !== '101480')
    }
    return () => {
      returnInplayValue(false);
      returnShouldShowStream(false);
    };
  }, [backupStreamUrl, eventData, liveAccordion]);

  const updateMatchOddsTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      matchOddsTopic !== currentTopic ||
      matchOddsBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setMatchOddsTopic(currentTopic);
      setMatchOddsBaseUrl(currentBaseUrl);
    }
  };

  const updateBookMakerTopic = (
    currentTopic: string,
    currentBaseUrl: string
  ) => {
    if (
      bookMakerTopic !== currentTopic ||
      bookMakerBaseUrl !== currentBaseUrl
    ) {
      disconnectToWS();
      setBookMakerTopic(currentTopic);
      setBookMakerBaseUrl(currentBaseUrl);
    }
  };

  const updateFancyTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (fancyTopic !== currentTopic || fancyBaseUrl !== currentBaseUrl) {
      disconnectToWS();
      setFancyTopic(currentTopic);
      setFancyBaseUrl(currentBaseUrl);
    }
  };

  const updatePremiumTopic = (currentTopic: string, currentBaseUrl: string) => {
    if (premiumTopic !== currentTopic || premiumBaseUrl !== premiumBaseUrl) {
      disconnectToWS();
      setPremiumTopic(currentTopic);
      setPremiumBaseUrl(currentBaseUrl);
    }
  };

  useEffect(() => {
    if (loggedIn && eventData) {
      setCFactor(CURRENCY_TYPE_FACTOR[getCurrencyTypeFromToken()]);
      if (
        eventData.sportId === '4' &&
        topicUrls?.bookMakerTopic &&
        topicUrls?.fancyTopic
      ) {
        updateFancyTopic(topicUrls?.fancyTopic, topicUrls?.fancyBaseUrl);
        subscribeWsForFancyMarkets(
          topicUrls?.fancyTopic,
          eventData?.eventId,
          'fancy',
          eventData.sportId,
          eventData.competitionId,
          false
        );
        if (
          secondaryMarkets?.bookmakers?.length &&
          topicUrls?.bookMakerBaseUrl
        ) {
          updateBookMakerTopic(
            topicUrls?.bookMakerTopic,
            topicUrls?.bookMakerBaseUrl
          );
          for (let itm of secondaryMarkets?.bookmakers) {
            subscribeWsForSecondaryMarkets(
              topicUrls?.bookMakerTopic,
              eventData?.eventId,
              itm.marketId
            );
          }
        }
      }

      if (topicUrls?.matchOddsTopic) {
        updateMatchOddsTopic(
          topicUrls?.matchOddsTopic,
          topicUrls?.matchOddsBaseUrl
        );
        for (let mo of secondaryMatchOdds) {
          subscribeWsForSecondaryMatchOdds(
            topicUrls?.matchOddsTopic,
            eventData.eventId,
            mo.marketId,
            eventData.providerName
          );
        }
      }

      if (
        seEventData?.markets?.matchOdds &&
        seEventData?.markets?.matchOdds?.length > 0 &&
        topicUrls?.premiumTopic
      ) {
        updatePremiumTopic(topicUrls?.premiumTopic, topicUrls?.premiumBaseUrl);
        subscribeSportRadarEventOdds(
          topicUrls?.premiumTopic,
          selectedEvent?.id,
          seEventData.eventId
        );
      }
    }
  }, [
    betFairWSConnected,
    selectedEvent,
    loggedIn,
    secondaryMatchOdds,
    secondaryMarkets,
  ]);

  useEffect(() => {
    let refreshInterval = setInterval(() => {
      if (loggedIn && eventData) {
        if (
          eventData.sportId === '4' &&
          topicUrls?.bookMakerTopic &&
          topicUrls?.fancyTopic
        ) {
          updateFancyTopic(topicUrls?.fancyTopic, topicUrls?.fancyBaseUrl);
          subscribeWsForFancyMarkets(
            topicUrls?.fancyTopic,
            eventData.eventId,
            'fancy',
            eventData.sportId,
            eventData.competitionId,
            false
          );
          if (secondaryMarkets?.bookmakers?.length) {
            updateBookMakerTopic(
              topicUrls?.bookMakerTopic,
              topicUrls?.bookMakerBaseUrl
            );
            for (let itm of secondaryMarkets?.bookmakers) {
              subscribeWsForSecondaryMarkets(
                topicUrls?.bookMakerTopic,
                eventData?.eventId,
                itm.marketId
              );
            }
          }
        }

        if (topicUrls?.matchOddsTopic) {
          updateMatchOddsTopic(
            topicUrls?.matchOddsTopic,
            topicUrls?.matchOddsBaseUrl
          );
          for (const smId of eventData?.secondaryMatchOddsMarketIds) {
            subscribeWsForSecondaryMatchOdds(
              topicUrls?.matchOddsTopic,
              eventData?.eventId,
              smId,
              eventData?.providerName
            );
          }
        }
        if (
          seEventData?.markets?.matchOdds &&
          seEventData?.markets?.matchOdds?.length > 0 &&
          topicUrls?.premiumTopic
        ) {
          updatePremiumTopic(
            topicUrls?.premiumTopic,
            topicUrls?.premiumBaseUrl
          );
          subscribeSportRadarEventOdds(
            topicUrls?.premiumTopic,
            eventData.eventId,
            seEventData.eventId
          );
        }
      }
    }, 1000 * 240);
    return () => {
      clearInterval(refreshInterval);
    };
  }, [betFairWSConnected, selectedEvent, loggedIn]);

  useEffect(() => {
    updateEventScorecard(null);
  }, [eventData?.eventId]);

  useEffect(() => {
    clearExchcngeBets();
    return () => {
      setExchEvent({ id: '', name: '', slug: '' });
    };
  }, []);

  useEffect(() => {
    if (loggedIn && enableFetchOrders && selectedEvent.id) {
      setTimeout(() => {
        fetchOpenBets(selectedEvent?.id, selectedEventType?.id);
        fetchOpenBetsRisk(selectedEvent?.id);
      }, 1000);
    }
  }, [loggedIn, triggerFetchOrders]);

  useEffect(() => {
    const [sportId, competitionId, eventId, marketTime] = atob(
      routeParams.eventInfo
    ).split(':');
    if (loggedIn && eventId && !backupStreamUrl) {
      let sportId: string = '';
      let competitionId: string = '';
      let eventId: string = '';
      let marketTime: string = '';
      const eventInfoArray = atob(routeParams.eventInfo).split(':');
      if (eventInfoArray.includes('sr')) {
        sportId = SPToBFIdMap[eventInfoArray.slice(0, 3).join(':')];
        competitionId = eventInfoArray.slice(3, 4).toString();
        eventId = eventInfoArray.slice(4, 5).toString();
        marketTime = eventInfoArray.slice(5, eventInfoArray.length).join(':');
      } else {
        [sportId, competitionId, eventId, marketTime] = atob(
          routeParams.eventInfo
        ).split(':');
      }
      fetchStreamUrl(sportId, competitionId, eventId);
    }
  }, [loggedIn, routeParams?.eventId]);

  useEffect(() => {
    let sportId: string;
    let competitionId: string;
    let eventId: string;
    let marketTime: string;
    const eventInfoArray = atob(routeParams.eventInfo).split(':');
    if (eventInfoArray.includes('sr')) {
      sportId = SPToBFIdMap[eventInfoArray.slice(0, 3).join(':')];
      competitionId = eventInfoArray.slice(3, 4).toString();
      eventId = eventInfoArray.slice(4, 5).toString();
      marketTime = eventInfoArray.slice(5, eventInfoArray.length).join(':');
    } else {
      [sportId, competitionId, eventId, marketTime] = atob(
        routeParams.eventInfo
      ).split(':');
    }
    fetchEvent(sportId, competitionId, eventId, marketTime);
    if (loggedIn && routeParams?.eventId) {
      setEnableFetchOrders(true);
      fetchOpenBets(eventId, sportId);
      fetchOpenBetsRisk(eventId);
    }
    const providerName = eventId?.includes('_') ? 'SportRadar' : 'BetFair';
    const sEventId = eventId?.includes('_')
      ? eventId.split('_').join(':')
      : eventId;
    const sCompetitionId = competitionId?.includes('_')
      ? competitionId.split('_').join(':')
      : competitionId;
    fetchPremiummarketsByEventId(
      providerName,
      sportId,
      sCompetitionId,
      sEventId,
      marketTime
    );
  }, [routeParams?.eventId]);

  useEffect(() => {
    if (eventData !== null) {
      const [sportId, competitionId, eventId, marketTime] = atob(
        routeParams.eventInfo
      ).split(':');
      fetchEvent(sportId, competitionId, eventId, '');
    }
  }, [triggerFetchMarkets]);

  // Get new Premium fancy markets
  useEffect(() => {
    if (loggedIn) {
      const [sportId, competitionId, eventId, marketTime] = atob(
        routeParams.eventInfo
      ).split(':');
      let refreshInterval = setInterval(() => {
        const pName = selectedEvent?.id.includes('_')
          ? 'SportRadar'
          : 'BetFair';
        const eventId = selectedEvent?.id.includes('_')
          ? selectedEvent?.id.split('_').join(':')
          : selectedEvent?.id;
        const sCompetitionId = competitionId?.includes('_')
          ? competitionId.split('_').join(':')
          : competitionId;
        fetchPremiummarketsByEventId(
          pName,
          selectedEventType.id,
          sCompetitionId,
          eventId,
          marketTime
        );
      }, 1000 * 30);
      return () => {
        clearInterval(refreshInterval);
      };
    }
  }, [loggedIn, selectedEvent?.id]);

  useEffect(() => {
    if (!openBetslip && bets.length > 0) {
      setOpenBetslip(true);
    }
  }, [bets]);

  useEffect(() => {
    if (loggedIn && eventData?.eventId) {
      unsubscribePNWsforEvents(houseId);
      unsubscribePNWsforEvents(parentId);
      subscribeWsForNotifications(
        false,
        houseId,
        eventData?.sportId,
        eventData?.competitionId,
        eventData?.eventId
      );
      subscribeWsForNotificationsPerAdminAllMarkets(
        false,
        houseId,
        parentId,
        accountId,
        eventData?.eventId
      );
      return () => {
        unsubscribePNWsforEvents(houseId);
        unsubscribePNWsforEvents(parentId + ':' + eventData?.eventId);
        if (!window.location.pathname.includes('==')) {
          subscribeWsForNotificationsPerAdmin(
            false,
            houseId,
            parentId,
            accountId
          );
          subscribeWsForNotifications(false, houseId);
        }
      };
    }
  }, [pushNotifWSConnection, loggedIn, eventData?.eventId]);

  const fetchStreamUrl = async (
    sportId: string,
    competitionId: string,
    eventId: string
  ) => {
    try {
      const response = await API_V2.get(`/catalog/v2/live-stream-links/`, {
        headers: {
          Authorization: sessionStorage.getItem('jwt_token'),
        },
        params: {
          providerId: PROVIDER_ID,
          sportId: sportId,
          competitionId: competitionId,
          eventId: eventId,
        },
      });

      if (response.status === 200 && response.data) {
        setBackupStreamUrl(response.data);
      } else {
        setBackupStreamUrl(null);
      }
    } catch (err) {
      setBackupStreamUrl(null);
    }
  };

  useEffect(() => {
    // let refreshInterval = setInterval(() => {
      if (topicUrls?.matchOddsBaseUrl) {
        const baseUrlsPayload = {
          matchOddsBaseUrl: topicUrls?.matchOddsBaseUrl,
          bookMakerAndFancyBaseUrl: topicUrls?.bookMakerBaseUrl,
          premiumBaseUrl: topicUrls?.premiumBaseUrl,
        };
        checkStompClientSubscriptions(baseUrlsPayload);
      }
    // }, 10000);
    // return () => {
    //   clearInterval(refreshInterval);
    // };
  }, []);


  useEffect(() => {
      if (['1', '2'].includes(eventData?.sportId)) setFancyTabVal(1);
      if (
        !secondaryMarkets?.fancyMarkets ||
        secondaryMarkets?.fancyMarkets?.length === 0
      ) {
        setFancyTabVal(1);
      } else {
        setFancyTabVal(0);
      }
    }, [secondaryMarkets]);
   

  const getFormattedMaxLimit = (max: number) => {
    const num = Number(max / cFactor);
    const fMax = Number(Math.floor(num / 50) * 50);
    return fMax > 999 ? Number(fMax / 1000).toFixed() + 'K' : fMax.toFixed();
  };

  const getFormattedMinLimit = (min: number) => {
    const num = Number(min / cFactor);
    const fMin = Number(Math.ceil(num / 10) * 10);
    return fMin > 999 ? Number(fMin / 1000).toFixed() + 'K' : fMin.toFixed();
  };

  const handleCollapse = () => {
    if (scorecardAccordion) {
      setScorecardAccordion(false);
      // setLiveAccordion(false);
    } else {
      setScorecardAccordion(true);
      // setLiveAccordion(false);
    }
  };
  const handleCollapse1 = () => {
    if (liveAccordion) {
      // setScorecardAccordion(false);
      setLiveAccordion(false);
    } else {
      // setScorecardAccordion(false);
      setLiveAccordion(true);
    }
  };
  useEffect(() => {
    if (eventData?.eventId && scorecardID === '') {
      loggedIn && getSPEventIdByBetfairId();
    }
  }, [eventData?.eventId]);

  useEffect(() => {
    if (seEventData?.eventId && scorecardID === '') {
      loggedIn && setScorecardID(seEventData?.eventId?.split(':')[2]);
    }
  }, [seEventData?.eventId]);

  const fetchOpenBetsRisk = async (eventId: string) => {
    try {
      if (!eventId || !loggedIn) {
        return;
      }

      const response = await API_V2.get(
        '/reports/v2/risk-management/user-risk',
        {
          headers: {
            Authorization: sessionStorage.getItem('jwt_token'),
          },
          params: {
            eventId: eventId,
          },
        }
      );
      setExposureMap(response.data.marketExposureMap);
    } catch (e) {
      console.log(e);
    }
  };

  const getSPEventIdByBetfairId = async () => {
    if (seEventData?.eventId) {
      setScorecardID(seEventData?.eventId?.split(':')[2]);
    } else {
      try {
        await API_SPORT_FEED.post(`/feed/get-sr-event-details`, {
          eventId: eventData?.eventId,
          token: getSapTokenFromToken(),
        }).then((result) => {
          if (result?.data?.status === 'RS_OK')
            setScorecardID(
              result?.data?.srEventDetails?.srEventId?.split(':')[2]
            );
          else setScorecardID('');
        });
      } catch (err) {
        setScorecardID('');
      }
    }
  };

  const getEventName = (index) => {
    let eventName = '';
    if (eventData?.eventName?.toLowerCase().includes(' v ')) {
      eventName = eventData?.eventName.split(' v ')[index];
    } else if (eventData?.eventName?.toLowerCase().includes(' vs. ')) {
      eventName = eventData?.eventName.split(' vs. ')[index];
    } else {
      eventName = index === 0 ? eventData?.eventName : '';
    }
    return eventName;
  };

  useEffect(() => {
    document.getElementsByClassName('router-ctn')[0].scrollIntoView();
  }, []);

  return (
    <div>
      {(loggedIn && eventData?.status === 'IN_PLAY') ||
      (loggedIn && seEventData?.status === 'IN_PLAY') ? (
        <div className="mob-icon-section mob-view">
          <div
            className={scorecardAccordion ? 'icon-ctn1' : 'icon-ctn'}
            onClick={() => {
              getSPEventIdByBetfairId();
              handleCollapse();
            }}
          >
            <IonIcon className="icon" src={scoreIcon} />
          </div>
          <div
            className={liveAccordion ? 'icon-ctn1' : 'icon-ctn'}
            onClick={() => handleCollapse1()}
          >
            <IonIcon className="icon" src={tvIcon} />
          </div>
          {/* <div
            className={showActionSheet ? 'icon-ctn1' : 'icon-ctn'}
            onClick={() => setShowActionSheet((prev) => !prev)}
          >
            <IonIcon className="icon" src={plusIcon} />
          </div> */}
        </div>
      ) : null}
      {eventData ? (
        <div className="eam-ctn">
          <div className="carw">
            <div className="arrow arrow-right">
              <div className="event-name">
                {eventData?.status === 'IN_PLAY' ||
                seEventData?.status === 'IN_PLAY' ? (
                  eventData?.competitionName
                ) : (
                  <CountDown expiryTimestamp={eventData?.openDate} />
                )}
              </div>
            </div>
          </div>
          {(eventData?.status === 'IN_PLAY' ||
            seEventData?.status === 'IN_PLAY') &&
          scorecardID !== '' ? (
            <Script
              strategy="afterInteractive"
              dangerouslySetInnerHTML={{
                __html: `
                (function(a,b,c,d,e,f,g,h,i){a[e]||(i=a[e]=function(){(a[e].q=a[e].q||[]).push(arguments)},i.l=1*new Date,i.o=f,
                g=b.createElement(c),h=b.getElementsByTagName(c)[0],g.async=1,g.src=d,g.setAttribute("n",e),h.parentNode.insertBefore(g,h)
                )})(window,document,"script", "https://widgets.sir.sportradar.com/8ee45b574e2781d581b0b0a133803906/widgetloader", "SIR", {
                    theme: false, // using custom theme
                    language: "en"
                });
                SIR("addWidget", ".sr-widget-1", "match.lmtPlus", {branding:{tabs:{option: "iconText", variant: "fullWidth"}},possessionOverlayTeamColored:true,showOdds:true,disablePitchStripes:true,disablePitchOverlay:true,disablePitchSpotlights:true,pitchLightStyle:true,layout: "double", scoreboard: "extended", momentum: "extended", collapseTo: "momentum", activeSwitcher: "scoreDetails", matchId:${scorecardID}});`,
              }}
            />
          ) : null}

          <IonCol className="eam-events-table-section">
            <IonRow className="eam-info-header">
              <div className="event-name">
                {getEventName(0)}
                {getEventName(1) !== '' ? (
                  <span className="vsIcon">Vs</span>
                ) : null}
                {getEventName(1)}
              </div>

              {(loggedIn && eventData?.status === 'IN_PLAY') ||
              (loggedIn && seEventData?.status === 'IN_PLAY') ? (
                <div className="icon-section web-view">
                  <div
                    className={scorecardAccordion ? 'icon-ctn1' : 'icon-ctn'}
                    onClick={() => {
                      getSPEventIdByBetfairId();
                      setScorecardAccordion(!scorecardAccordion);
                    }}
                  >
                    <IonIcon className="icon" src={scoreIcon} />
                  </div>
                  <div
                    className={liveAccordion ? 'icon-ctn1' : 'icon-ctn'}
                    onClick={() => setLiveAccordion(!liveAccordion)}
                  >
                    <IonIcon className="icon" src={tvIcon} />
                  </div>
                </div>
              ) : null}
            </IonRow>
            {(loggedIn && eventData?.status === 'IN_PLAY') ||
            (loggedIn && seEventData?.status === 'IN_PLAY' && loggedIn) ? (
              <>
                {' '}
                <Collapse
                  in={scorecardAccordion}
                  timeout="auto"
                  unmountOnExit
                  className="Collapse-card"
                >
                  <div className="widgets">
                    <div>
                      <div className="sr-widget sr-widget-1"></div>
                    </div>
                  </div>
                </Collapse>
                {eventData?.competitionId !== '101480' && <Collapse
                  in={liveAccordion}
                  timeout="auto"
                  unmountOnExit
                  className="Collapse-card mob-view"
                >
                  {' '}
                  <div className="scorecard-ctn">
                    <CricketLiveStream
                      eventID={eventData.eventId}
                      providerUrl={backupStreamUrl}
                    />
                  </div>
                </Collapse>}
              </>
            ) : null}

            {loggedIn ? (
              <Accordion
                className="stream-accordion mob-view"
                defaultExpanded={true}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon className="expand-icon" />}
                  aria-controls="panel1a-content"
                  className="stream-header"
                >
                  <div className="title"> Open Bets ({totalOrders})</div>
                </AccordionSummary>
                <AccordionDetails className="stream-body">
                  {totalOrders > 0 ? <ExchOpenBets /> : null}
                </AccordionDetails>
                {totalOrders > 25 ? (
                  <NavLink to="/my_bets" className="navlink">
                    View all
                  </NavLink>
                ) : null}
              </Accordion>
            ) : null}
            {eventData.providerName !== 'SportRadar' ? (
              <IonRow className="eam-table-section">
                <MatchOddsTable
                  exposureMap={exposureMap}
                  getFormattedMinLimit={getFormattedMinLimit}
                  getFormattedMaxLimit={getFormattedMaxLimit}
                  eventData={eventData}
                  secondaryMatchOdds={secondaryMatchOdds}
                  loggedIn={loggedIn}
                />
              </IonRow>
            ) : null}
            {secondaryMarkets?.bookmakers?.length > 0 &&
            secondaryMarkets?.bookmakers?.[0].runners.length > 0 ? (
              <>
                <IonRow className="eam-section-divider"></IonRow>
                <IonRow className="eam-table-section">
                  <BmMTable
                    exposureMap={exposureMap}
                    loggedIn={loggedIn}
                    enableBookmaker={secondaryMarkets?.enableBookmaker}
                    getFormattedMinLimit={getFormattedMinLimit}
                    getFormattedMaxLimit={getFormattedMaxLimit}
                    bmMData={bmMData}
                    eventData={eventData}
                  />
                </IonRow>
              </>
            ) : null}
            <IonRow className="eam-table-section fancy-tab-section">
              {secondaryMarkets?.fancyMarkets?.length > 0 ||
              seEventData?.markets?.matchOdds?.length > 0 ? (
                <>
                  {fancyTabVal == 0 ? (
                    <Tabs
                      value={fancyTabVal}
                      className="fancy-market-tabs"
                      onChange={(_, newValue) => {
                        setFancyTabVal(newValue);
                      }}
                    >
                      {secondaryMarkets?.fancyMarkets?.length > 0 ? (
                        <Tab label="Fancy" className="fancy-tab" value={0} />
                      ) : null}

                      {seEventData?.markets?.matchOdds?.length > 0 ? (
                        <Tab
                          label="Premium"
                          className="fancy-tab premium-markets"
                          value={1}
                        />
                      ) : null}
                    </Tabs>
                  ) : (
                    <Tabs
                      value={fancyTabVal}
                      className="fancy-market-tabs"
                      onChange={(_, newValue) => {
                        setFancyTabVal(newValue);
                      }}
                    >
                      {seEventData?.markets?.matchOdds?.length > 0 ? (
                        <Tab
                          label="Premium"
                          className="fancy-tab premium-markets"
                          value={1}
                        />
                      ) : null}
                      {secondaryMarkets?.fancyMarkets?.length > 0 ? (
                        <Tab label="Fancy" className="fancy-tab" value={0} />
                      ) : null}
                    </Tabs>
                  )}
                  <IonRow>
                    <TabPanel
                      value={fancyTabVal}
                      index={0}
                      className="fancy-tab-ctn"
                    >
                      {secondaryMarkets?.fancyMarkets?.length > 0 ? (
                        <>
                          <FMTable
                            exposureMap={exposureMap}
                            loggedIn={loggedIn}
                            enableFancy={secondaryMarkets?.enableFancy}
                            getFormattedMinLimit={getFormattedMinLimit}
                            getFormattedMaxLimit={getFormattedMaxLimit}
                            fmData={fmData}
                            eventData={eventData}
                          />
                        </>
                      ) : null}
                    </TabPanel>

                    <IonRow className="row-100">
                      {' '}
                      <TabPanel
                        value={fancyTabVal}
                        index={1}
                        className="fancy-tab-ctn"
                      >
                        {seEventData?.markets?.matchOdds?.length > 0 ? (
                          <>
                            <PremiumMarketsView
                              loggedIn={loggedIn}
                              dreamData={eventData}
                              getFormattedMinLimit={getFormattedMinLimit}
                              getFormattedMaxLimit={getFormattedMaxLimit}
                            />
                          </>
                        ) : (
                          <div className="no-fancy-msg">No Premium Markets</div>
                        )}
                      </TabPanel>
                    </IonRow>
                  </IonRow>
                </>
              ) : null}
            </IonRow>
          </IonCol>
        </div>
      ) : null}
      {/* <div className="mob-view">
        <BottomSheet
          showActionSheet={showActionSheet}
          setShowActionSheet={setShowActionSheet}
          className="mob-view"
        />
      </div> */}
    </div>
  );
};

const mapStateToProps = (state: RootState, ownProps) => {
  const selectedEvent = state.exchangeSports.selectedEvent;
  return {
    bmMData: getBookmakerMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    fmData: getFancyMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    eventData: getAllMarketsByEvent(
      state.exchangeSports.premiumMarketsMap,
      state.exchangeSports.events,
      state.exchangeSports.selectedEventType.id,
      state.exchangeSports.selectedCompetition.id,
      selectedEvent.id
    ),
    secondaryMarkets: getSecondaryMarketsByEvent(
      state.exchangeSports.secondaryMarketsMap,
      selectedEvent.id
    ),
    secondaryMatchOdds: getSecondaryMatchOddsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
    seEventData: getPremiumMarkets(
      state.exchangeSports.premiumMarketsMap,
      selectedEvent.id
    ),
    lineMarkets: getLineMarketsByEvent(
      state.exchangeSports.secondaryMatchOddsMap,
      selectedEvent.id
    ),
    selectedEventType: state.exchangeSports.selectedEventType,
    selectedEvent: selectedEvent,
    bets: state.exchBetslip.bets,
    openBets: state.exchBetslip.openBets,
    totalOrders: state.exchBetslip.totalOrders,
    loggedIn: state.auth.loggedIn,
    streamUrl: state.common.streamUrl,
    topicUrls: state?.exchangeSports?.topicUrls,
    houseId: getHouseIdFromToken(),
    parentId: getParentIdFromToken(),
    accountId: getAccountIdFromToken(),
    triggerFetchMarkets: state.exchangeSports.triggerFetchMarkets,
    triggerFetchOrders: state.exchangeSports.triggerFetchOrders,
    betFairWSConnected: state.exchangeSports.betFairWSConnected,
    pushNotifWSConnection: state.exchangeSports.pushNotifWSConnection,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    clearExchcngeBets: () => dispatch(clearExchcngeBets()),
    fetchOpenBets: (eventId: string, sportId: string) =>
      dispatch(fetchOpenBets(eventId, sportId)),
    fetchEvent: (
      sportId: string,
      competitionId: string,
      eventId: string,
      marketTime: string
    ) => dispatch(fetchEvent(sportId, competitionId, eventId, marketTime)),
    fetchPremiummarketsByEventId: (
      providerId: string,
      competitionId: string,
      sportId: string,
      eventId: string,
      marketTime: string
    ) =>
      dispatch(
        fetchPremiummarketsByEventId(
          providerId,
          competitionId,
          sportId,
          eventId,
          marketTime
        )
      ),
    setExchEvent: (event: SelectedObj) => dispatch(setExchEvent(event)),
    updateEventScorecard: (scorecard: any) =>
      dispatch(updateEventScorecard(scorecard)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExchAllMarkets);
